export const featureColor = {
    // Make these colors distinct for each feature type
    Image: "#dd00dd",
    "Inspection-Image": "#00dddd",
    "Deviation-Image": "#dddd00",
    Deviation: "#DD0000",
    Inspection: "#0000DD",
    Egenkontroller: "#0000DD",
  };